













import Vue from "vue";
import moment from "moment-timezone";

export default class Footer extends Vue {
  name: "Footer";

  get startYear(): string {
    return "2021";
  }
  get endYear(): string {
    const date: Date = moment().tz("Asia/Tokyo").toDate();
    return String(date.getFullYear());
  }
  get displayYear(): string {
    if (this.startYear === this.endYear) {
      return this.startYear;
    }
    return `${this.startYear}-${this.endYear}`;
  }
}
